import Typography from '@mui/material/Typography';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import { AppLinkRoot } from 'components/core/AppLink/AppLink';
import Grid from 'components/core/Grid';
import { userNextRouteTransitions } from 'hooks/useNextRouteTransitions';

const LinkButtons = ({ buttonData }: { buttonData: { onClick: () => void; title: string }[] }) => {
  return (
    <>
      {buttonData.map(item => (
        <Grid item xs={12} key={item.title}>
          <AppLinkRoot onClick={item.onClick} isButtonLink>
            {item.title}
          </AppLinkRoot>
        </Grid>
      ))}
    </>
  );
};

export const SignupActivated = () => {
  const {
    navigateToAlluraWhistlerPage,
    navigateToAlluraBigWhitePage,
    navigateToAlluraSunPeaksPage,
    navigateToAlluraHome,
  } = userNextRouteTransitions();

  const buttonData = [
    { onClick: navigateToAlluraWhistlerPage, title: 'Whistler' },
    { onClick: navigateToAlluraBigWhitePage, title: 'Big White' },
    { onClick: navigateToAlluraSunPeaksPage, title: 'Sun Peaks' },
    { onClick: navigateToAlluraHome, title: 'Other' },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AppDivider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2">
          Thank you for joining and being part of the alluraDirect community. Our hosts are looking forward to giving
          you an amazing experience at their properties.
        </Typography>
      </Grid>

      {/* TODO: implement referrals */}
      <Grid item xs={12}>
        <AppDivider />
      </Grid>

      {/* <GiveEarnCredits creditsData={creditsQuery.data} userId={parseInt(guestId as string)} /> */}

      {/* <Grid item xs={12}>
        <AppDivider />
      </Grid> */}

      <Grid item xs={12}>
        <Typography variant="h5">Start your Search</Typography>
        <Typography variant="body2">Where would you like to go?</Typography>
      </Grid>
      <LinkButtons buttonData={buttonData} />
    </Grid>
  );
};
